<div #gridHeader class="header">
	<div class="header-buttons">
		@if (addLink && !isOnlyDispatcher()) {
			<a routerLink="{{ addLink }}" class="btn btn-secondary">
				<i class="fas fa-plus"></i>
			</a>
		}
		&nbsp;
		@if (showFilters) {
			<button type="button" class="btn btn-secondary" (click)="filersClicked()">
				<i class="fas fa-filter"></i>
			</button>
		}
		&nbsp;
		<button type="button" class="btn btn-secondary" (click)="calendarOpen()">
			<i class="far fa-calendar-alt"></i>
		</button>
	</div>
	<div class="arrows">
		<button type="button" class="btn btn-danger" (click)="dateMove(-7)">
			<i class="fas fa-angle-double-left"></i> tydzień
		</button>
		<button type="button" class="btn btn-danger right" (click)="dateMove(7)">
			tydzień <i class="fas fa-angle-double-right"></i>
		</button>
	</div>
	<div class="header-day" *ngFor="let day of days">
		{{ day.date }}
		<div class="header-dayOfWeek">{{ day.dayOfWeek }}</div>
		<div class="header-hour" *ngFor="let hour of hours">
			{{ hour }}
		</div>
	</div>
</div>

<div class="modal fade" id="calendarModal" tabindex="-1">
	<div class="modal-dialog modal-dialog-centered">
		<div class="modal-content">
			<div class="modal-header">
				<button type="button" class="btn-close" (click)="calendarClose()"></button>
			</div>
			<div class="modal-body">
				<div class="form-floating mb-3">
					<input
						type="date"
						class="form-control"
						name="setDate"
						id="setDate"
						[(ngModel)]="setDate"
						data-date-inline-picker="true"
					/>
					<label for="setDate">Data</label>
				</div>
			</div>
			<div class="modal-footer">
				<div class="container">
					<div class="row">
						<div class="col-sm-4">
							<button type="button" class="btn btn-danger" (click)="dateToday()">Dzisiaj</button>
						</div>
						<div class="col-sm-8 text-end">
							<button type="button" class="btn btn-primary me-2" (click)="calendarSubmit()">
								Przejdź do wybranej daty
							</button>
							<button
								type="button"
								class="btn btn-secondary"
								data-bs-dismiss="modal"
								(click)="calendarClose()"
							>
								Anuluj
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div
	#grid
	class="data"
	(mousedown)="mousedown($event)"
	(mouseup)="mouseup($event)"
	(touchstart)="touchstart($event)"
	(touchend)="touchend($event)"
	(touchmove)="touchmove($event)"
>
	<div
		class="data-row"
		*ngFor="let row of gridData"
		[ngStyle]="{ 'height.px': row.height, background: row.background }"
		[class]="row?.class"
		[id]="row?.tableElementId"
	>
		<div class="data-label" [ngStyle]="{ 'height.px': row.height }">
			{{ row.name }}
			<div class="timeline-tooltip" *ngIf="row.details">
				<p class="tooltip-content" *ngFor="let detail of row.details">
					{{ detail.label }}
					<span [innerHTML]="detail.value"></span>
				</p>
			</div>
		</div>
		@for (item of row.items; track item.id) {
			@let slotsParsed = item.slots ? item.slots?.departureOk + '/' + item.slots?.departureOp : '';
			<abbr
				matTooltip="{{ item.name }} {{ slotsParsed }}"
				class="data-cell"
				[ngStyle]="item.style"
				(click)="elementClicked(item)"
			>
				{{ item.icon }}
				{{ item.name }}
				<app-tourism-event-transport-term-slots [slots]="item.slots" />
			</abbr>
		}
	</div>
</div>
